export default __webpack_public_path__ + "static/media/Ballroll_00349.4e1802da.png";